/**
 * axios 请求拦截器
 * 请求前生成 csrf token
 */

import axios from 'axios'
import cookie from 'cookie'
import qs from 'qs'
import store from '@/apps/open/store'
import { priSubPath } from '@/apps/open/constants/index'
import Cookie from 'js-cookie'

const isPrivate = process.env.VUE_APP_IS_PRIVATE
const priWebPath = `/${location.pathname.split('/').pop()}`
const IS_DEV = process.env.NODE_ENV === 'development'

if (isPrivate) {
  var { getQueryString, CRYPT_AES_KEY, decryptAES, encryptAES } = require('@/apps/open/utils/priCrypto')
}
interface RowCookie {
  csrf?: string
}

class CSRFToken {
  token: string
  isCreate: boolean
  constructor (private cookie:RowCookie) {
    this.token = cookie.csrf || ''
    this.isCreate = true

    if (!this.token) {
      let $chars:string = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos:number = $chars.length

      for (let i = 0; i < 32; i++) {
        this.token += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      this.isCreate = false
    }
  }
}

export default function () {
  axios.interceptors.request.use(config => {
    if (config.method === 'post' && config.headers['Content-Type'] && config.headers['Content-Type'].includes('multipart/form-data')) {
      return config
    }

    let data = qs.parse(config.data)

    let { token, isCreate } = new CSRFToken(cookie.parse(document.cookie))

    data.csrfmiddlewaretoken = token

    if (!isCreate) {
      document.cookie = cookie.serialize('csrf', token, {
        path: '/',
        domain: '.wps.cn'
      })
    }

    // 跨域的GET请求需要带上csrftoken
    if (
      config.baseURL && config.baseURL.indexOf(window.location.host) === -1 &&
      config.method === 'get'
    ) {
      config.transformRequest = [
        (data) => JSON.stringify(data)
      ]
    }
    if (isPrivate) {
      config.data = {
        csrfmiddlewaretoken: Cookie.get('csrf'),
        ...config.data
      }
      const needCrypto = store.getters['needCrypto']
      let apiUrl: string = config.url as string
      if (apiUrl.indexOf('/api/') === 0 || apiUrl.indexOf('/mdfile') === 0) {
        config.url = needCrypto ? IS_DEV ? `${priSubPath}${priWebPath}${apiUrl}` : `${priSubPath}${priWebPath}` : `${priSubPath}${priWebPath}${apiUrl}`
      } else if (apiUrl.indexOf('/p/') === 0) {
        config.url = needCrypto ? `${priSubPath}/account` : `${priSubPath}/account${apiUrl}`
      } else if (apiUrl.indexOf('/oauth/') === 0) {
        config.url = needCrypto ? `${priSubPath}/oauth-svr` : `${priSubPath}/oauth-svr${apiUrl}`
      } else if (apiUrl.indexOf('/plussvr/') === 0) {
        if (needCrypto) {
          config.url = `${priSubPath}/plussvr`
          apiUrl = apiUrl.split('/plussvr')[1]
        } else {
          config.url = `${priSubPath}${apiUrl}`
        }
      } else if (apiUrl.indexOf('/drive/') === 0) {
        if (needCrypto) {
          config.url = `${priSubPath}/drive`
          apiUrl = apiUrl.split('/drive')[1]
        } else {
          config.url = `${priSubPath}${apiUrl}`
        }
      } else if (apiUrl.indexOf('/openapi/') === 0) {
        config.url = needCrypto ? `${priSubPath}/openapi` : `${priSubPath}${apiUrl}`
        apiUrl = apiUrl.split('/openapi')[1]
      } else if (apiUrl.indexOf('/koauthapi/') === 0) {
        config.url = needCrypto ? `${priSubPath}/koauthapi` : `${priSubPath}${apiUrl}`
        apiUrl = apiUrl.split('/koauthapi')[1]
      } else {
        config.url = `${priSubPath}${apiUrl}`
      }
      if (needCrypto) {
        config.headers['Encryption-Algorithm'] = 'AES256'
        config.headers['Content-Type'] = 'application/json'
        config.headers['Encryption-Parameters'] = CRYPT_AES_KEY
        const APIInfo = {
          schema: location.protocol.substring(0, location.protocol.length - 1),
          method: (config.method as string).toUpperCase(),
          api: apiUrl,
          query_string: getQueryString(config.params)
        }
        config.headers['API-Parameters'] = encryptAES(APIInfo)
        config.method = 'POST'
        config.params = {}
        config.data = config.data ? encryptAES(config.data) : ''
      }
    }
    return config
  })
  axios.interceptors.response.use(response => {
    if (response.headers.encryption === '1' && response.data) {
      response.data = decryptAES(response.data)
    }
    return response
  }, function (error) {
    if (error.response.headers.encryption === '1' && error.response.data) {
      error.response.data = decryptAES(error.response.data)
    }
    return Promise.reject(error)
  })
}
